import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import RPCCheckerView from "../views/RPCCheckerView.vue";
import BnbSenderView from "../views/BnbSenderView.vue";
import CreateCustomTransactionView from "../views/CreateCustomTransactionView.vue";
import GetCurrentBlockNumberView from "../views/GetCurrentBlockNumberView.vue";
import SwapExactETHForTokenView from "../views/SwapExactETHForTokenView.vue";
import TransactionMonitorView from "../views/TransactionMonitorView.vue";
import AddLiquidityETHWatcherView from "../views/AddLiquidityETHWatcherView.vue";
import PresaleContractCheckerView from "../views/PresaleContractCheckerView.vue";
import DxsaleListingMonitorView from "../views/DxsaleListingMonitorView.vue";
import DxsaleDisableWhitelistMonitorView from "../views/DxsaleDisableWhitelistMonitorView.vue";
import DxsaleDisableWhitelistMonitorWithMetaMaskView from "../views/DxsaleDisableWhitelistMonitorWithMetaMaskView.vue";
import UnicryptUserDepositView from "../views/UnicryptUserDepositView.vue";
import UnicryptV3UserDepositView from "../views/UnicryptV3UserDepositView.vue";
import UnicryptV4ApproveView from "../views/UnicryptV4ApproveView.vue";
import UnicryptV4ReserveView from "../views/UnicryptV4ReserveView.vue";
import UnicryptV4Reserve2View from "../views/UnicryptV4Reserve2View.vue";
import UnicryptV4UserDepositView from "../views/UnicryptV4UserDepositView.vue";
import UnicryptV4UserDeposit2View from "../views/UnicryptV4UserDeposit2View.vue";
import PurchaseByITAM from "../views/PurchaseByITAMView.vue";
import BuyJoJoView from "../views/BuyjojoView.vue";
import JojoWatcherView from "../views/JojoWatcherView.vue";
import BinemonEggView from "../views/BinemonEggView.vue";
import BuyStarmonView from "../views/BuyStarmonView.vue";
import PinkSalePresaleInfoView from "../views/pinksale/PresaleInfoView.vue";
import PinkSaleWhitelistMonitorView from "../views/pinksale/DisableWhitelistMonitorView.vue";
import PinkSaleContributeView from "../views/pinksale/ContributeView.vue";
import AstronautInvestingView from "../views/astronaut/InvestingView.vue";
import AstronautStartAstroshotRoundMonitorView from "../views/astronaut/StartAstroshotRoundMonitorView.vue";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "PresaleContractCheckerView",
    component: PresaleContractCheckerView,
  },
  {
    path: "/rpcChecker",
    name: "RPCChecker",
    component: RPCCheckerView,
  },
  {
    path: "/bnbSender",
    name: "BnbSender",
    component: BnbSenderView,
  },
  {
    path: "/createCustomTransaction",
    name: "CreateCustomTransaction",
    component: CreateCustomTransactionView,
  },
  {
    path: "/getCurrentBlockNumber",
    name: "GetCurrentBlockNumber",
    component: GetCurrentBlockNumberView,
  },
  {
    path: "/swapExactETHForToken",
    name: "SwapExactETHForToken",
    component: SwapExactETHForTokenView,
  },
  {
    path: "/transactionMonitor",
    name: "TransactionMonitor",
    component: TransactionMonitorView,
  },
  {
    path: "/addLiquidityETHWatcher",
    name: "AddLiquidityETHWatcher",
    component: AddLiquidityETHWatcherView,
  },
  {
    path: "/presaleContractChecker",
    name: "PresaleContractCheckerView",
    component: PresaleContractCheckerView,
  },
  {
    path: "/dxsaleListingMonitor",
    name: "dxsaleListingMonitor",
    component: DxsaleListingMonitorView,
  },
  {
    path: "/dxsaleDisableWhitelistMonitor",
    name: "dxsaleDisableWhitelistMonitor",
    component: DxsaleDisableWhitelistMonitorView,
  },
  {
    path: "/dxsaleDisableWhitelistMonitorWithMetaMask",
    name: "dxsaleDisableWhitelistMonitorWithMetMask",
    component: DxsaleDisableWhitelistMonitorWithMetaMaskView,
  },
  {
    path: "/unicryptUserDeposit",
    name: "unicryptUserDeposit",
    component: UnicryptUserDepositView,
  },
  {
    path: "/unicryptV3UserDeposit",
    name: "unictyptV3UserDeposit",
    component: UnicryptV3UserDepositView,
  },
  {
    path: "/unicryptV4approve",
    name: "unicryptV4approve",
    component: UnicryptV4ApproveView,
  },
  {
    path: "/unicryptV4reserve",
    name: "unicryptV4reserve",
    component: UnicryptV4ReserveView,
  },
  {
    path: "/unicryptV4reserve2",
    name: "unicryptV4reserve2",
    component: UnicryptV4Reserve2View,
  },
  {
    path: "/unicryptV4UserDeposit",
    name: "unicryptV4UserDeposit",
    component: UnicryptV4UserDepositView,
  },
  {
    path: "/unicryptV4UserDeposit2",
    name: "unicryptV4UserDeposit2",
    component: UnicryptV4UserDeposit2View,
  },
  {
    path: "/purchaseByITAM",
    name: "puchaseBuITAM",
    component: PurchaseByITAM,
  },
  {
    path: "/buyjojo",
    name: "buyJoJo",
    component: BuyJoJoView,
  },
  {
    path: "/jojoWatcher",
    name: "jojoWatcher",
    component: JojoWatcherView,
  },
  {
    path: "/binemonEgg",
    name: "binemonEgg",
    component: BinemonEggView,
  },
  {
    path: "/buyStarmon",
    name: "buyStarmon",
    component: BuyStarmonView,
  },
  {
    path: "/pinksale/presaleInfo",
    name: "PinkSalePresaleInfo",
    component: PinkSalePresaleInfoView,
  },
  {
    path: "/pinksale/disableWhitelistMonitor",
    name: "PinkSaleDisableWhitelistMonitor",
    component: PinkSaleWhitelistMonitorView,
  },
  {
    path: "/pinksale/contribute",
    name: "Contribute",
    component: PinkSaleContributeView,
  },
  {
    path: "/astronaut/investing",
    name: "AstronautInvesting",
    component: AstronautInvestingView,
  },
  {
    path: "/astronaut/startastroshotroundmonitor",
    name: "AstronautStartAstroshotRoundMonitor",
    component: AstronautStartAstroshotRoundMonitorView
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
